import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { Box, Tabs, Tab } from '@mui/material';
import CustomerLogin from './CustomerLogin';
import CustomerSetup from './CustomerSetup';
import CustomerLayout from './CustomerLayout';
import CustomerOrderForm from './CustomerOrderForm';
import CustomerOrderList from './CustomerOrderList';
import { customerAuth } from './customerAuth';

const CustomerDashboard = () => {
    const [tab, setTab] = useState(0);
    const [refreshKey, setRefreshKey] = useState(0);

    return (
        <Box>
            <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ mb: 2 }}>
                <Tab label="New Order" />
                <Tab label="My Orders" />
            </Tabs>
            {tab === 0 && <CustomerOrderForm onOrderCreated={() => { setRefreshKey(k => k + 1); setTab(1); }} />}
            {tab === 1 && <CustomerOrderList refreshKey={refreshKey} />}
        </Box>
    );
};

const CustomerApp = () => {
    const location = useLocation();
    const [authenticated, setAuthenticated] = useState(customerAuth.isAuthenticated());
    const successMessage = location.state?.message || '';

    if (!authenticated) {
        return <CustomerLogin onLogin={() => setAuthenticated(true)} initialMessage={successMessage} />;
    }

    return (
        <CustomerLayout onLogout={() => setAuthenticated(false)}>
            <CustomerDashboard />
        </CustomerLayout>
    );
};

const SetupPage = () => {
    const navigate = useNavigate();

    return (
        <CustomerSetup onComplete={() => navigate('/customer', { state: { message: 'Password set successfully. You can now sign in.' } })} />
    );
};

const CustomerPortalRouter = () => (
    <BrowserRouter>
        <Routes>
            <Route path="/customer/setup" element={<SetupPage />} />
            <Route path="/customer/*" element={<CustomerApp />} />
            <Route path="/customer" element={<CustomerApp />} />
        </Routes>
    </BrowserRouter>
);

export default CustomerPortalRouter;
